<section class="admin-grid">
  <div class="grid-header">
    <h3>{{ title }}</h3>

    <div class="actions">
      <div class="search-bar" *ngIf="searchable">
        <input
          [(ngModel)]="searchTerm"
          (input)="applySearch()"
          type="text"
          placeholder="Search..."
        />
      </div>

      <button *ngIf="addEnabled" class="new-btn" (click)="onAdd()">new</button>
    </div>
  </div>

  <div class="grid-wrapper">
    <table>
      <thead>
        <tr>
          <th *ngFor="let col of columns" (click)="col.sortable && onSort(col.field)">
            {{ col.header }}
          </th>
          <th class="actions-header">Actions</th>
        </tr>
      </thead>

      <tbody>
        <tr *ngFor="let row of filteredData" class="clickable">
          <td *ngFor="let col of columns">{{ row[col.field] }}</td>
          <td class="actions">
            <button class="icon-btn view" (click)="onRowClick(row)">
              <svg viewBox="0 0 24 24">
                <path
                  fill="currentColor"
                  d="M12 5c-7 0-11 7-11 7s4 7 11 7 11-7 11-7-4-7-11-7zm0 12a5 5 0 1 1 0-10 5 5 0 0 1 0 10z"
                />
              </svg>
            </button>
            <button class="icon-btn edit" (click)="onEdit(row)">
              <svg viewBox="0 0 24 24">
                <path
                  fill="currentColor"
                  d="M5 18.5v2.5h2.5l7.4-7.4-2.5-2.5L5 18.5zM20.7 7c.2-.2.2-.5 0-.7l-3-3a.5.5 0 0 0-.7 0l-2 2 3.7 3.7 2-2z"
                />
              </svg>
            </button>
            <button class="icon-btn delete" (click)="onDelete(row)">
              <svg viewBox="0 0 24 24">
                <path
                  fill="currentColor"
                  d="M6 19a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V7H6v12zm3.46-9.12L10.88 8.5l1.12 1.12 1.12-1.12 1.42 1.38L13.54 10l1.12 1.12-1.42 1.38L12 11.46l-1.12 1.12-1.42-1.38L10.46 10l-1.12-1.12zM15.5 4l-1-1h-5l-1 1H5v2h14V4h-3.5z"
                />
              </svg>
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <div *ngIf="filteredData.length === 0" class="empty-state">
    <p>No records found.</p>
  </div>

  <!-- 🔥 Unified modal with dynamic lookups -->
  <app-modal
    [visible]="modalVisible"
    [mode]="modalMode"
    [data]="activeRow"
    [entityLabel]="entityLabel"
    [lookups]="lookupLists"
    (confirm)="handleModalConfirm($event)"
    (close)="handleModalClose()"
  ></app-modal>
</section>
